import { range } from './range';
export function calculatePageOptions({
  firstPage,
  currentPage,
  lastPage,
  alwaysShowFirstPage,
  alwaysShowLastPage,
  delta
}) {
  const middleFrom = Math.max(Math.min(currentPage - delta, lastPage - delta * 2 - (alwaysShowLastPage ? 2 : 1)), firstPage);
  const middleTo = Math.min(Math.max(currentPage + delta, firstPage + delta * 2 + (alwaysShowFirstPage ? 2 : 1)), lastPage);
  const a = middleFrom - firstPage;
  const b = lastPage - middleTo;
  return [
  // prettier-ignore
  ...(alwaysShowFirstPage ? a > 2 ? [firstPage, '...'] : a > 1 ? [firstPage, firstPage + 1] : a > 0 ? [firstPage] : [] : a > 1 ? ['...'] : a > 0 ? [firstPage] : []), ...range({
    from: middleFrom,
    to: middleTo
  }),
  // prettier-ignore
  ...(alwaysShowLastPage ? b > 2 ? ['...', lastPage] : b > 1 ? [lastPage - 1, lastPage] : b > 0 ? [lastPage] : [] : b > 1 ? ['...'] : b > 0 ? [lastPage] : [])];
}